import { Directive, ElementRef, OnInit, Optional } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { ValidatorService } from './validator.service';

@Directive({
  selector: 'p-dropdown[appRegisterValidator]',
})
export class RegisterDropDownValidatorDirective implements OnInit {
  constructor(@Optional() private componentRef: Dropdown, private elementRef: ElementRef, private validatorService: ValidatorService) {
    /** */
  }
  ngOnInit(): void {
    if (this.componentRef != null) {
      this.validatorService.registerDropDown(this.elementRef.nativeElement.id, this.componentRef);
    }
  }
}
